import React from "react";
import { useTranslation } from "react-i18next";
import PageShell from "components/bento/PageShell";
import ShippingCalculatorPanel from "components/ShippingCalculatorPanel";

// Staff shipping calculator. Open to every logged-in staff user (no page permission —
// see ALWAYS_VISIBLE_PAGES in utils/pagePermissions.js), so quoting a price at the
// counter doesn't require a role change.
const CalculatorPage = () => {
  const { t } = useTranslation();

  return (
    <PageShell title={t("shippingCalculator.title")} subtitle={t("shippingCalculator.subtitle")}>
      <ShippingCalculatorPanel />
    </PageShell>
  );
};

export default CalculatorPage;
